import React from 'react';
import { Link } from 'react-router-dom';
import './choose_method.css'

function ChooseMethod() {
  return (
      <div className="cm container-sm">
         <div className="d-flex justify-content-center text-center profile-title">
              <p className="h4">Apakah anda ingin membuat ITIN dari rekomendasi LIWAT?</p>
        </div>
        <div className="d-flex justify-content-center">
            <Link className="button-outline button" to="/itin/create/from-bucketlist">
                Dari Bucket List
            </Link>
            <Link className="button-filled button" to="/itin/create/from-recommendation">
                Dari Rekomendasi
            </Link>
        </div>

      </div>
  );
}

export default ChooseMethod

